import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OnboardingGuard } from './security/onboarding.guard';
import { LoginCallbackComponent } from './security/login-callback/login-callback.component';
import { LogoutCallbackComponent } from './security/logout-callback/logout-callback.component';
import { SecureGuard } from './security/secure.guard';

const routes: Routes = [
  { path: '', redirectTo: '/secure', pathMatch: 'full'},
  { path: 'auth/signin-oidc', component: LoginCallbackComponent },
  { path: 'auth/signout-oidc', component: LogoutCallbackComponent },
  {
    path: 'anonymous',
    loadChildren: () =>
      import('./anonymous/anonymous.module').then((m) => m.AnonymousModule)
  },
  {
    path: 'secure',
    canActivate: [SecureGuard],
    loadChildren: () =>
      import('./secure/secure.module').then((m) => m.SecureModule)
  },
  {
    path: 'onboarding',
    canActivate: [OnboardingGuard],
    loadChildren: () =>
      import('./onboarding/onboarding.module').then((m) => m.OnboardingModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
